import { createFileRoute } from "@tanstack/react-router";
import OverDeHusselApp from "@/pages/OverDeHusselApp";

export const Route = createFileRoute("/over-de-hussel-app")({
  head: () => ({
    meta: [
      { title: "Over De Hussel App – Het verhaal achter de app" },
      { name: "description", content: "Ontdek waarom De Hussel App is gebouwd. Automatische hussel-indelingen voor tennis- en padelclubs, bedacht en gebouwd door Oscar van Heeswijk." },
      { property: "og:title", content: "Over De Hussel App – Het verhaal achter de app" },
      { property: "og:description", content: "Ontdek waarom De Hussel App is gebouwd. Automatische hussel-indelingen voor tennis- en padelclubs, bedacht en gebouwd door Oscar van Heeswijk." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://dehusselapp.nl/over-de-hussel-app" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://dehusselapp.nl/over-de-hussel-app" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          name: "Over De Hussel App",
          description: "Het verhaal achter De Hussel App, gebouwd door Oscar van Heeswijk.",
          url: "https://dehusselapp.nl/over-de-hussel-app",
        }),
      },
    ],
  }),
  component: OverDeHusselApp,
});
